(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.site-header');
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const localeSwitchers = document.querySelectorAll('[data-locale-switcher]');

  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (menuToggle && mobileMenu) {
    const closeMobileMenu = () => {
      menuToggle.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      mobileMenu.hidden = true;
      document.body.classList.remove('is-mobile-menu-open');
    };

    const openMobileMenu = () => {
      menuToggle.classList.add('is-open');
      menuToggle.setAttribute('aria-expanded', 'true');
      mobileMenu.hidden = false;
      document.body.classList.add('is-mobile-menu-open');
    };

    menuToggle.addEventListener('click', () => {
      if (menuToggle.classList.contains('is-open')) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMobileMenu);
    });

    document.addEventListener('click', (event) => {
      if (mobileMenu.hidden) return;
      if (!header.contains(event.target)) {
        closeMobileMenu();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !mobileMenu.hidden) {
        closeMobileMenu();
      }
    });
  }

  localeSwitchers.forEach((localeSwitcher) => {
    localeSwitcher.addEventListener('change', (event) => {
      const form = event.target.closest('form');
      if (form) {
        form.submit();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-search-live]');
    if (!root) return;

    const searchUrl = root.dataset.searchUrl;
    const resultsSection = root.dataset.resultsSection;
    const debounceMs = Number(root.dataset.debounce) || 350;
    const minChars = Number(root.dataset.minChars) || 2;
    const allowedSections = new Set(['search-results']);
    const allowedTypes = new Set(['all', 'product', 'page']);

    if (!allowedSections.has(resultsSection)) return;

    const form = root.querySelector('[data-search-form]');
    const input = root.querySelector('[data-search-input]');
    const panel = root.querySelector('[data-search-panel]');
    const filtersWrap = root.querySelector('[data-search-filters]');
    const filterButtons = root.querySelectorAll('[data-search-filter]');
    const clearButton = root.querySelector('[data-search-clear]');
    const lead = root.querySelector('[data-search-lead]');
    const status = root.querySelector('[data-search-status]');
    const typeInput = root.querySelector('[data-search-type-input]');

    let activeFilter = root.dataset.activeFilter || 'all';
    let debounceTimer = null;
    let abortController = null;

    function setLoading(isLoading) {
      panel.classList.toggle('is-loading', isLoading);
      panel.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (isLoading) {
        status.textContent = root.dataset.loading;
      } else {
        status.textContent = '';
      }
    }

    function updateLead(hasQuery) {
      lead.textContent = hasQuery ? root.dataset.leadActive : root.dataset.leadDefault;
    }

    function toggleClear(show) {
      clearButton.hidden = !show;
    }

    function toggleFilters(show) {
      filtersWrap.classList.toggle('is-hidden', !show);
    }

    function setActiveFilter(filter) {
      if (!allowedTypes.has(filter)) return;
      activeFilter = filter;
      filterButtons.forEach((button) => {
        const isActive = button.dataset.searchFilter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (filter === 'all') {
        typeInput.value = '';
        typeInput.disabled = true;
      } else {
        typeInput.value = filter;
        typeInput.disabled = false;
      }
    }

    function buildUrl(query) {
      const params = new URLSearchParams();
      params.set('section_id', resultsSection);
      params.set('q', query);
      if (activeFilter !== 'all') {
        params.set('type', activeFilter);
      }
      return `${searchUrl}?${params.toString()}`;
    }

    function updateBrowserUrl(query) {
      const params = new URLSearchParams();
      if (query) {
        params.set('q', query);
      }
      if (activeFilter !== 'all' && query) {
        params.set('type', activeFilter);
      }
      const nextUrl = query ? `${searchUrl}?${params.toString()}` : searchUrl;
      window.history.replaceState({ searchQuery: query }, '', nextUrl);
    }

    function extractPanel(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('[data-search-results-panel]');
    }

    async function fetchResults(query) {
      if (abortController) {
        abortController.abort();
      }

      abortController = new AbortController();
      setLoading(true);

      try {
        const response = await fetch(buildUrl(query), {
          signal: abortController.signal,
        });

        if (!response.ok) {
          throw new Error('Search request failed');
        }

        const html = await response.text();
        const nextPanel = extractPanel(html);

        if (nextPanel) {
          const currentPanel = panel.querySelector('[data-search-results-panel]');
          if (currentPanel) {
            currentPanel.replaceWith(nextPanel);
          } else {
            panel.appendChild(nextPanel);
          }
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error(error);
        }
      } finally {
        setLoading(false);
      }
    }

    function runSearch(query, { updateUrl = true } = {}) {
      const trimmed = query.trim();
      input.setAttribute('aria-expanded', trimmed.length >= minChars ? 'true' : 'false');

      if (trimmed.length === 0) {
        toggleFilters(false);
        toggleClear(false);
        updateLead(false);
        if (updateUrl) {
          updateBrowserUrl('');
        }
        fetchResults('');
        return;
      }

      toggleClear(true);

      if (trimmed.length < minChars) {
        return;
      }

      toggleFilters(true);
      updateLead(true);
      if (updateUrl) {
        updateBrowserUrl(trimmed);
      }
      fetchResults(trimmed);
    }

    input.addEventListener('input', () => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(() => {
        runSearch(input.value);
      }, debounceMs);
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      window.clearTimeout(debounceTimer);
      runSearch(input.value);
    });

    clearButton.addEventListener('click', () => {
      input.value = '';
      setActiveFilter('all');
      window.clearTimeout(debounceTimer);
      runSearch('');
      input.focus();
    });

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setActiveFilter(button.dataset.searchFilter);
        if (input.value.trim().length >= minChars) {
          window.clearTimeout(debounceTimer);
          runSearch(input.value);
        }
      });
    });

    window.addEventListener('popstate', () => {
      const params = new URLSearchParams(window.location.search);
      const query = params.get('q') || '';
      const type = allowedTypes.has(params.get('type')) ? params.get('type') : 'all';
      input.value = query;
      setActiveFilter(type);
      runSearch(query, { updateUrl: false });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
